var _pattern, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProgressTrackerdottedProgress = function SvgProgressTrackerdottedProgress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    "aria-hidden": "true"
  }, props), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "progressTrackerdottedProgress_svg__a",
    width: 4,
    height: 8,
    x: 0,
    y: 0,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#0064D2"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: "100%",
    fill: "url(#progressTrackerdottedProgress_svg__a)"
  })));
};
export default SvgProgressTrackerdottedProgress;